module.exports = __webpack_public_path__ + "static/media/wordmark_white.6e0b4637.svg";